export const mainNav = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' }, // dropdown
    { label: 'About', href: '/about' },
    // { label: 'Our Work', href: '/Our Work' },
    { label: 'Blog', href: '/blog' },
    { label: 'Contact', href: '/contact-us' },
];
export const services = [
    {
        label: 'Article Publishing',
        href: '/article-publishing',
    },
    {
        label: 'Author Website Design',
        href: '/author-website-design',
    },
    {
        label: 'Blog Writing',
        href: '/blog-writing',
    },
    {
        label: 'Book Cover Design',
        href: '/book-cover-design',
    },
    {
        label: 'Book Formatting',
        href: '/book-formatting',
    },
    {
        label: 'Book Illustration',
        href: '/book-illustration',
    },
    {
        label: 'Book Video Trailer',
        href: '/book-video-trailer',
    },
    {
        label: 'Children’s Book Publishing',
        href: '/childrens-book-publishing',
    },
    {
        label: 'Proofreading & Editing',
        href: '/proofreading-editing',
    },
    {
        label: 'SEO Content Writing',
        href: '/seo-content-writing',
    },
    {
        label: 'Website Content Writing',
        href: '/website-content-writing',
    },
    {
        label: 'Fiction Writing',
        href: '/fiction-writing',
    },
    {
        label: 'Non-fiction Writing',
        href: '/non-fiction-writing',
    },
];

export const serviceCategories = [
    {
        title: 'Publishing Services',
        url: '/services',
        icon: 'book-open',
        links: [
            ['Book Publishing', '/book-publishing'], // ✅ added
            ['Book Writing', '/book-writing'], // ✅ added
            ['Article Publishing', '/article-publishing'],
            ['Children’s Book Publishing', '/childrens-book-publishing'],
            ['Book Formatting', '/book-formatting'],
            ['Book Illustration', '/book-illustration'],
            ['Book Video Trailer', '/book-video-trailer'],
            ['Audiobook', '/audiobook'], // ✅ added
        ],
    },
    {
        title: 'Design Services',
        url: '/services',
        icon: 'palette',
        links: [
            ['Book Cover Design', '/book-cover-design'],
            ['Author Website Design', '/author-website-design'],
        ],
    },
    {
        title: 'Writing Services',
        url: '/book-writing',
        icon: 'pen-tool',
        links: [
            ['Fiction Writing', '/fiction-writing'],
            ['Non-fiction Writing', '/non-fiction-writing'],
            ['Blog Writing', '/blog-writing'],
            // (optional) remove duplicate:
            // ['Article Publishing', '/article-publishing'],
        ],
    },
    {
        title: 'Content & Editing',
        url: '/services',
        icon: 'file-text',
        links: [
            ['Proofreading & Editing', '/proofreading-editing'],
            ['SEO Content Writing', '/seo-content-writing'],
            ['Website Content Writing', '/website-content-writing'],
        ],
    },
    {
        title: 'Marketing',
        url: '/services',
        icon: 'users',
        links: [
            ['Book Marketing', '/book-marketing'], // ✅ added (new category)
        ],
    },
];

// Optional: right-side promo card content for desktop dropdown
export const servicesPromo = {
    title: 'Need help choosing a service?',
    subtitle: 'Get a free 15-min consultation with our expert.',
    ctaLabel: 'Book a call',
    ctaHref: '/contact-us',
    secondaryLabel: 'View all services',
    secondaryHref: '/services',
    bullets: ['Quick response', 'No obligation', 'Clear next steps'],
    image: '/need-help.jpg', // optional; remove if you don’t want an image
};
